// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const CreditMemo = t.struct({
    accountCity: t.maybe(t.String),
    accountName: t.maybe(t.String),
    accountNumber: t.maybe(t.String),
    accountState: t.maybe(t.String),
    approvedCoreValue: t.maybe(t.Number),
    approvedDiagnosticAmount: t.maybe(t.Number),
    approvedDiagnosticHours: t.maybe(t.Number),
    approvedLaborAdditive: t.maybe(t.Number),
    approvedLaborAmount: t.maybe(t.Number),
    approvedLaborHours: t.maybe(t.Number),
    approvedLaborTotal: t.maybe(t.Number),
    approvedOnshelfCost: t.maybe(t.Number),
    approvedOtherCredits: t.maybe(t.Number),
    approvedParts: t.maybe(t.Number),
    approvedPartsAdditive: t.maybe(t.Number),
    approvedPartsTotal: t.maybe(t.Number),
    approvedRepairAmount: t.maybe(t.Number),
    approvedRepairHours: t.maybe(t.Number),
    approvedTaxesTotal: t.maybe(t.Number),
    approvedTravelTotal: t.maybe(t.Number),
    basicWarrantyEndDate: t.maybe(t.Number),
    basicWarrantyStartDate: t.maybe(t.Number),
    claimNumber: t.maybe(t.String),
    claimType: t.maybe(t.String),
    claimTypeDescription: t.maybe(t.String),
    creditMemoNumber: t.maybe(t.String),
    currency: t.maybe(t.String),
    customerName: t.maybe(t.String),
    dateIssued: t.maybe(t.Number),
    dealerInvoiceNumber: t.maybe(t.String),
    deductible: t.maybe(t.Number),
    deliveryDate: t.maybe(t.Number),
    failureDate: t.maybe(t.Number),
    failureMode: t.maybe(t.String),
    failurePart: t.maybe(t.String),
    failurePartDescription: t.maybe(t.String),
    formDisplay: t.maybe(t.String),
    invoiceReference: t.maybe(t.String),
    invoiceRequest: t.maybe(t.String),
    leadAccount: t.maybe(t.String),
    machineUse: t.maybe(t.String),
    originalSubmissionDate: t.maybe(t.Number),
    payer: t.maybe(t.String),
    pin: t.maybe(t.String),
    pipNumber: t.maybe(t.String),
    pipsUnpaidLaborAdditives: t.maybe(t.Number),
    planName: t.maybe(t.String),
    programDescription: t.maybe(t.String),
    programName: t.maybe(t.String),
    referenceNumber1: t.maybe(t.String),
    referenceNumber2: t.maybe(t.String),
    repairDate: t.maybe(t.Number),
    repairNumber: t.maybe(t.String),
    requestDiagnosticAmount: t.maybe(t.Number),
    requestDiagnosticHours: t.maybe(t.Number),
    requestRepairAmount: t.maybe(t.Number),
    requestRepairHours: t.maybe(t.Number),
    requestedLaborAmount: t.maybe(t.Number),
    requestedLaborHours: t.maybe(t.Number),
    requestedOtherCredits: t.maybe(t.Number),
    requestedParts: t.maybe(t.Number),
    requestedTravelTotal: t.maybe(t.Number),
    subClaimType: t.maybe(t.String),
    subClaimTypeDescription: t.maybe(t.String),
    techId: t.maybe(t.String),
    totalApprovedClaimValue: t.maybe(t.Number),
    totalApprovedIncludingTaxes: t.maybe(t.Number),
    totalRequestedClaimValue: t.maybe(t.Number),
    totalUnpaid: t.maybe(t.Number),
    unitOfMeasure: t.maybe(t.String),
    unpaidLabor: t.maybe(t.Number),
    unpaidLaborAdditivesExcludingPips: t.maybe(t.Number),
    unpaidOtherCredits: t.maybe(t.Number),
    unpaidParts: t.maybe(t.Number),
    unpaidPartsAdditive: t.maybe(t.Number),
    unpaidTravel: t.maybe(t.Number),
    warrantyType: t.maybe(t.String)
}, {
    name: 'CreditMemo',
    strict: true
});

export const getDefaultState = () => new CreditMemo({});

export default CreditMemo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/credit-memo.js